module.exports = __webpack_public_path__ + "static/media/Special-Section-Tube-Mild-Steel.3b77154c.jpg";